import { getFileSpriteIconClass } from 'owa-file-icon';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';

const classNames = require('classnames');
const styles = require('./fileProvidersIcon.scss');

export default function getIconForFileProvider(icon: string, className: string): JSX.Element {
    return <Icon iconName={icon} className={className} />;
}

export function getIconForGDrive(isBig?: boolean): JSX.Element {
    return (
        <Icon
            className={classNames([
                styles.pngGoogleIcon,
                getFileSpriteIconClass(isBig ? 'gdrive_64x64' : 'gdrive_24x24'),
            ])}
            tabIndex={-1}
            data-is-focusable={false}
        />
    );
}
